// MST
import { IAnyModelType, types } from 'mobx-state-tree'

// Interfaces
import { COLUMN_TYPE, QUESTION_LAYOUT } from 'constant/shared.constant'

// Helper
import { withHelper_questionModel } from './question.helper'
import { withHelper_answerModel } from './answer.helper'
import { withHelper_commonLoadingModel } from './common.helper'

// Types
const { optional, model, maybeNull, enumeration, array, late, number, string } = types

export const withHelper_questionSetHeaderModel = model('QuestionSetHeader').props({
  id: maybeNull(number),
  title: maybeNull(string),
  children: optional(array(late((): IAnyModelType => withHelper_questionSetHeaderModel)), []),
})

export const withHelper_questionSetResultDetailModel = model('QuestionSetResultDetail').props({
  id: maybeNull(string),
  headerId: maybeNull(number),
  childrenHeaderId: maybeNull(number),
  type: maybeNull(enumeration('Type', Object.values(COLUMN_TYPE))),
  question: maybeNull(withHelper_questionModel),
  answer: maybeNull(withHelper_answerModel),

  // For Front-End Only
  loading: withHelper_commonLoadingModel,
})

export const withHelper_questionSetResultModel = model('QuestionSetResult').props({
  id: maybeNull(string),
  kukNumber: maybeNull(string),
  resultDetail: optional(array(withHelper_questionSetResultDetailModel), []),
})

export const withHelper_questionGroupModel = model('QuestionGroup').props({
  qGroupid: maybeNull(number),
  instruction: maybeNull(string),
  header: optional(array(withHelper_questionSetHeaderModel), []),
  result: optional(array(withHelper_questionSetResultModel), []),
})

export const withHelper_questionSetProps = {
  questionSetId: maybeNull(number),
  questionSetLayout: maybeNull(enumeration('QuestionSetLayout', Object.values(QUESTION_LAYOUT))),
  groupData: optional(array(withHelper_questionGroupModel), [])
}

export const withHelper_questionSetModel = model('QuestionSet').props({
  ...withHelper_questionSetProps,
})
